import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import MyHeader from './Header.module.css';
import DocumentTitle from '../DocumentTitle/DocumentTitle';
import Logo from '../Logo/Logo';
import favIcon from '../../assets/Icon feather-star.svg';
import privateIcon from '../../assets/lock.svg';
import publicIcon from '../../assets/world.svg';
import Navigations from '../Navigations/Navigations';
import SavingSaved from '../SavingSaved';

const LeftHeaderTop = ({ isMobile, showNav, toggleNav, leftActionsRef }) => {
    const documentInformation = useSelector((state) => state.editor.documentInformation);
    return (
        <div className={MyHeader.leftHeaderTop} role="banner">
            <div className={MyHeader.leftTitleWrap}>
                <DocumentTitle isMobile={isMobile} showNav={showNav} toggleNav={toggleNav} />
                <div ref={leftActionsRef} className={MyHeader.leftActions}>
                    {documentInformation && documentInformation.privacyId === 2 ? (
                        <img src={privateIcon} alt="Private document" className={MyHeader.leftActionIcon} />
                    ) : (
                        <img src={publicIcon} alt="Public document" className={MyHeader.leftActionIcon} />
                    )}
                    <SavingSaved />
                </div>
            </div>
        </div>
    );
};

const LeftHeaderBottom = ({ isMobile }) => {
    const isReadOnly = useSelector((state) => state.editor.isReadOnly);
    return (
        !isReadOnly && (
            <div className={MyHeader.leftHeaderBottom}>
                <Navigations />
            </div>
        )
    );
};

const LeftHeader = ({ isMobile, leftRef, leftActionsRef }) => {
    const [showNav, setShowNav] = useState(false);
    const headerRef = useRef(null);

    // Close dropdown on outside click
    useEffect(() => {
        const handleClick = (e) => {
            if (!showNav) return;
            const headerElement = headerRef.current || leftRef?.current;
            if (headerElement && !headerElement.contains(e.target)) {
                setShowNav(false);
            }
        };
        const handleKey = (e) => {
            if (!showNav) return;
            if (e.key === 'Escape') setShowNav(false);
        };
        document.addEventListener('click', handleClick);
        document.addEventListener('keydown', handleKey);
        return () => {
            document.removeEventListener('click', handleClick);
            document.removeEventListener('keydown', handleKey);
        };
    }, [showNav, leftRef]);
    return (
        <div className={MyHeader.leftHeader} ref={(node) => { headerRef.current = node; if (leftRef) leftRef.current = node; }} role="banner">
            <div className={MyHeader.logoContainer}>
                <Logo isMobile={isMobile} />
            </div>
            <div className={MyHeader.leftHeaderContent}>
                <LeftHeaderTop isMobile={isMobile} showNav={showNav} toggleNav={() => setShowNav((s) => !s)} leftActionsRef={leftActionsRef} />
                {/* LeftHeaderBottom should be hidden on small devices (see CSS) — we render a dropdown overlay for mobile*/}
                <LeftHeaderBottom isMobile={isMobile} />
                {isMobile && showNav && (
                    <div className={MyHeader.navDropdown} role="menu">
                        <Navigations />
                    </div>
                )}
            </div>
        </div>
    );
};

export default LeftHeader;